import React, { memo } from 'react';
import { AccordionTypeTokens, } from '@voltmoney/schema';
import { AccordionDefault } from './AccordionDefault.base';
import { AccordionList } from './AccordionList.base';
/**
 * Primary UI component for user interaction
 */
const Accordion = ({ id, type = AccordionTypeTokens.DEFAULT, ...props }) => {
    switch (type) {
        case AccordionTypeTokens.DEFAULT:
            return React.createElement(AccordionDefault, { ...props, id: id });
        case AccordionTypeTokens.LIST:
            return React.createElement(AccordionList, { ...props, id: id });
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(Accordion);
export { Accordion };
